module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_01_A.39d03832.png";